module.exports = __webpack_public_path__ + "img/loginbackground.04be8fc3.png";